import { Box, Button, Stack, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router";
import FrostedCard from "./FrostedCard";
import JerryPill from "./JerryPill";
import StatusIcon from "./StatusIcon";
import StepHeader from "./StepHeader";
import { amberCtaSx } from "./amberCtaSx";
import { useT, useTRich } from "src/i18n";

export default function KiitosScreen({ result, email }) {
    const theme = useTheme();
    const easing = theme.custom?.wizard?.motion?.easing ?? "cubic-bezier(0.22, 1, 0.36, 1)";
    const isOpen = result?.status === "open";
    const t = useT();
    const tRich = useTRich();
    return (
        <Box sx={{ maxWidth: 720, mx: "auto", px: { xs: 2, md: 4 }, py: { xs: 4, md: 6 } }}>
            <FrostedCard
                blur={28}
                sx={{
                    p: { xs: 3, md: 4 },
                    borderRadius: 3,
                    // Terminal payoff: the card rises, then the status check
                    // confirms a beat later — one small orchestrated moment, no
                    // confetti (the price/terms credibility stays intact).
                    animation: `bjKiitosIn 360ms ${easing}`,
                    "@keyframes bjKiitosIn": {
                        from: { opacity: 0, transform: "translateY(8px)" },
                        to: { opacity: 1, transform: "translateY(0)" },
                    },
                    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
                }}
            >
                <Stack spacing={2.5} sx={{ alignItems: "flex-start" }}>
                    <StepHeader>{t("wizard.kiitos.title")}</StepHeader>
                    <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
                        <Box sx={{
                            flexShrink: 0,
                            pt: 0.25,
                            transformOrigin: "center",
                            animation: `bjCheckIn 400ms ${easing} 120ms backwards`,
                            "@keyframes bjCheckIn": {
                                from: { opacity: 0, transform: "scale(0.85)" },
                                to: { opacity: 1, transform: "scale(1)" },
                            },
                            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
                        }}>
                            <StatusIcon tone={isOpen ? "success" : "warn"} size={28} />
                        </Box>
                        <Box sx={{
                            fontFamily: "'Inter', sans-serif",
                            fontSize: "1rem",
                            color: "text.secondary",
                            lineHeight: 1.6,
                        }}>
                            {isOpen
                                ? tRich("wizard.kiitos.openBody", {
                                    id: <strong>#{result.pumppuRequestId}</strong>,
                                    email: email ? <strong>({email})</strong> : "",
                                })
                                : tRich("wizard.kiitos.noSupplyBody", {
                                    id: <strong>#{result.pumppuRequestId}</strong>,
                                    email: email ? <strong>({email})</strong> : "",
                                })}
                        </Box>
                    </Stack>
                    {isOpen && (
                        <JerryPill message={t("wizard.kiitos.jerryMessage")} />
                    )}
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to="/valut"
                        sx={{ ...amberCtaSx(theme), alignSelf: "flex-start" }}
                    >
                        {t("wizard.kiitos.followOffers")}
                    </Button>
                </Stack>
            </FrostedCard>
        </Box>
    );
}
